export default {
    title: `Nouvelle version disponible`,
    text: `Suite à une mise à jour de Kolsquare par nos équipes, vous devez recharger l’application pour continuer à utiliser Kolsquare (seulement quelques secondes seront nécessaires).`,
    button: `Recharger l'application`,
};
